<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Báo cáo tiết dạy" :link="[{ text: 'Báo cáo tiết dạy', href: '/teacher-class-report' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <div class="d-flex align-center justify-space-between">
        <v-btn dark outlined class="search-button" @click="backMonth">
          Tháng trước
        </v-btn>
        <div>
          Tháng từ:
          <span class="text-h6 font-weight-bold">
            {{ startMonth | ddmmyyyy }}
          </span>
          đến
          <span class="text-h6 font-weight-bold">
            {{ endMonth | ddmmyyyy }}
          </span>
        </div>
        <v-btn dark outlined class="search-button" @click="nextMonth">
          Tháng sau
        </v-btn>
      </div>
    </v-card>

    <v-card class="ma-4 mt-6 pa-4">
      <div class="d-flex justify-center flex-column align-center" v-if="fetchLoading">
        <v-progress-circular indeterminate color="primary" class="mb-4" />
        <div class="primary--text">Đang tổng kết dữ liệu...</div>
      </div>
      <div v-else>
        <div v-show="!slots.length">
          Hiện chưa có dữ liệu báo cáo tiết dạy cho tháng hiện tại
        </div>
        <div v-show="slots.length > 0">
          <div class="d-flex justify-end mb-4">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="search-button" outlined color="success" v-bind="attrs" v-on="on">
                  <v-icon left>mdi-file-excel</v-icon> Xuất Excel
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="exportDiffExcel">
                  <v-list-item-title>Báo cáo GV lệch tiết dạy</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportAllExcel">
                  <v-list-item-title>Báo cáo tổng hợp</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportDetailExcel">
                  <v-list-item-title>Báo cáo chi tiết</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-data-table :headers="tableHeader" :items="slots" :footer-props="footerTable" :key="tableKey" disable-sort>
            <template #item.name="{ item }">
              <router-link style="text-decoration: none" :to="'/teacher/' + item.id">
                <div class="teacher-name">{{ item.name }}</div>
              </router-link>
            </template>
            <template #item.actions="{ item }">
              <span style="cursor: pointer" @click="() => goToDetail(item)" v-if="item.count > 0">
                <v-icon color="primary">mdi-eye</v-icon>
              </span>
            </template>
            <template #item.count="{ item }">
              <span>
                <span class="font-weight-medium">{{ item.realCount }}</span>
                <span>/{{ item.count }}</span>
              </span>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { groupBy, get } from 'lodash'
import moment from 'moment'
import XLSX from 'xlsx'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'

export default {
  components: {
    Breadcrumbs
  },
  data() {
    return {
      slots: [],
      tableKey: Date.now(),
      tableHeader: [
        {
          text: 'Họ tên',
          value: 'name',
          width: '25%'
        },
        {
          text: 'Số tiết thực tế/TKB',
          value: 'count',
          align: 'center'
        },
        {
          text: 'Thao tác',
          value: 'actions',
          width: '10%'
        }
      ],
      date: moment().toISOString(),
      fetchLoading: false
    }
  },
  async mounted() {
    await this.onFetchData()
  },
  computed: {
    footerTable() {
      let footer = {
        'items-per-page-text': 'Hiển thị mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 20,
        'items-per-page-options': [10, 20, -1]
      }
      return footer
    },
    startMonth() {
      return moment(this.date)
        .startOf('month')
        .toISOString()
    },
    endMonth() {
      return moment(this.date)
        .endOf('month')
        .toISOString()
    }
  },
  methods: {
    ...mapActions('ClassNotes', ['fetchReportByTeacher']),
    async onFetchData() {
      this.fetchLoading = true
      this.slots = await this.fetchReportByTeacher({ date_gte: this.startMonth, date_lte: this.endMonth })
      this.tableKey = Date.now()
      this.fetchLoading = false
    },
    nextMonth() {
      this.date = moment(this.endMonth)
        .add(1, 'days')
        .toISOString()
      this.onFetchData()
    },
    backMonth() {
      this.date = moment(this.startMonth)
        .subtract(1, 'days')
        .toISOString()
      this.onFetchData()
    },
    goToDetail(item) {
      this.$router.push(`/teacher-class-report/${item.id}/${this.date}`)
    },
    exportDiffExcel() {
      const data = this.slots.filter(x => x.realCount !== x.count)
      if (data.length) {
        const formatData = data.map((item, index) => ({
          STT: index + 1,
          'Họ tên': item.name,
          'Số tiết thực tế/TKB': `${item.realCount}/${item.count}`
        }))
        const wb = XLSX.utils.book_new()
        // create title
        const ws = XLSX.utils.aoa_to_sheet([
          [`Báo cáo giáo viên lệch tiết dạy`.toUpperCase()],
          [`Tháng ${moment(this.date).format('MM-YYYY')}`.toUpperCase()]
        ])
        // merge title
        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } }
        ]

        XLSX.utils.sheet_add_json(ws, formatData, { origin: 'A4' })
        XLSX.utils.book_append_sheet(wb, ws, 'data')
        XLSX.writeFile(wb, `Báo cáo giáo viên lệch tiết dạy tháng ${moment(this.date).format('MM-YYYY')}.xlsx`)
      } else {
        this.$alert.warn('Không có giáo viên nào lệch tiết dạy')
      }
    },
    exportAllExcel() {
      const wb = XLSX.utils.book_new()

      this.slots.forEach(teacher => {
        const formatData = teacher.classNotes.map(x => ({
          Ngày: this.$options.filters.ddmmyyyy(x.date),
          Lớp: x.class,
          Môn: x.subject,
          Thứ: this.$options.filters.scheduleDay(x.day),
          Tiết: x.index,
          'Trạng thái tiết dạy': x.status === 'on-time' || x.status === 'late' ? 'Đã dạy' : ''
        }))
        // create title
        const ws = XLSX.utils.aoa_to_sheet([
          [`Báo cáo tổng hợp tiết dạy`.toUpperCase()],
          [`Tháng ${moment(this.date).format('MM-YYYY')}`.toUpperCase()],
          [''],
          [`Họ tên giáo viên: ${teacher.name}`],
          [`Số tiết dạy thực tế/TKB: ${teacher.realCount}/${teacher.count}`]
        ])
        // merge title
        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: 5 } },
          { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
          { s: { r: 3, c: 0 }, e: { r: 3, c: 5 } },
          { s: { r: 4, c: 0 }, e: { r: 4, c: 5 } }
        ]
        XLSX.utils.sheet_add_json(ws, formatData, { origin: 'A7' })
        XLSX.utils.book_append_sheet(wb, ws, teacher.name)
      })

      XLSX.writeFile(wb, `Báo cáo tổng hợp tiết dạy tháng ${moment(this.date).format('MM/YYYY')}.xlsx`)
    },
    exportDetailExcel() {
      const workBook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.aoa_to_sheet([])

      const excelHeader = [
        { text: 'TT', value: 'index' },
        { text: 'Họ và tên GV', value: 'name' },
        { text: 'Môn', value: 'subject' },
        { text: 'Lớp', value: 'class' }
      ]
      const weeks = this.getWeeksInMonth()
      weeks.forEach((week, index) => {
        const weekText = `${week.weekStart.format('D')}-${week.weekEnd.format('D')}/${week.weekStart.format('M')}`
        excelHeader.push({
          text: `Tuần ${index + 1} |\n ${weekText}`,
          value: `week${index + 1}`
        })
      })
      excelHeader.push({ text: 'Tổng', value: 'sum' })

      const excelData = []
      const mergeArr = []
      let rowIndex = 0
      this.slots.forEach((slot, index) => {
        const classNotesBySubject = groupBy(slot.classNotes, 'subject')
        let numOfClass = 0
        // Giáo viên không có lớp
        if (Object.keys(classNotesBySubject).length === 0) {
          excelData.push({
            index: index + 1,
            name: slot.name
          })
          rowIndex++
        } else {
          Object.keys(classNotesBySubject)
            .sort()
            .forEach(subject => {
              const classNotesByClass = groupBy(classNotesBySubject[subject], 'class')
              const numOfClassWithSubject = Object.keys(classNotesByClass).length
              numOfClass += numOfClassWithSubject
              Object.keys(classNotesByClass)
                .sort()
                .forEach(className => {
                  const data = {}
                  // STT
                  data.index = index + 1
                  // Họ và tên GV
                  data.name = slot.name
                  // Môn
                  data.subject = subject
                  // Lớp
                  data.class = className
                  // Tuần
                  const classNotes = classNotesByClass[className].filter(classNote => classNote.status === 'on-time')
                  let total = 0
                  // Loop week
                  weeks.forEach((week, index) => {
                    let count = 0
                    classNotes.map(classNote => {
                      if (
                        moment(classNote.date).isSameOrAfter(week.weekStart) &&
                        moment(classNote.date).isSameOrBefore(week.weekEnd)
                      ) {
                        count++
                      }
                    })
                    total += count
                    data[`week${index + 1}`] = count
                  })
                  // Tổng
                  data.sum = total
                  excelData.push(data)
                  rowIndex++
                })
              if (numOfClassWithSubject > 1) {
                // Merge cột môn (subject column)
                mergeArr.push({ s: { r: rowIndex - numOfClassWithSubject + 1, c: 2 }, e: { r: rowIndex, c: 2 } })
                // const cellReference = XLSX.utils.encode_cell({ r: rowIndex - numOfClassWithSubject + 1, c: 2 })
                // const cellStyle = {
                //   alignment: {
                //     vertical: 'center'
                //   }
                // }
                // worksheet[cellReference] = { t: 's', s: cellStyle }
              }
            })
        }
        if (numOfClass > 0) {
          // Merge cột số thứ tự (index column)
          mergeArr.push({ s: { r: rowIndex - numOfClass + 1, c: 0 }, e: { r: rowIndex, c: 0 } })
          // Merge cột Họ và tên GV (name column)
          mergeArr.push({ s: { r: rowIndex - numOfClass + 1, c: 1 }, e: { r: rowIndex, c: 1 } })
        }
      })
      const tableData = excelData.map(item => {
        let dataRow = {}
        excelHeader.map(header => {
          dataRow[header.text] = get(item, header.value, '')
        })
        return dataRow
      })

      // weeks.forEach((week, index) => {
      //   const startWeek = week.weekStart.format('D')
      //   const endWeek = week.weekEnd.format('D')
      //   const month = week.weekStart.format('M')
      //   const weekText = `${startWeek}\n${endWeek}/${month}`
      //   const cellReference = XLSX.utils.encode_cell({ r: 0, c: index + 4 })
      //   const cellStyle = {
      //     alignment: {
      //       horizontal: 'center',
      //       vertical: 'center'
      //     }
      //   }
      //   console.log(weekText)
      //   worksheet[cellReference] = { t: 's', v: weekText, s: cellStyle }
      // })

      worksheet['!merges'] = [...mergeArr]
      XLSX.utils.sheet_add_json(worksheet, tableData)
      const workSheetName = `Tháng ${moment(this.date).format('MM.YY')}`
      XLSX.utils.book_append_sheet(workBook, worksheet, workSheetName)

      const excelFileName = `Báo cáo chi tiết tháng ${moment(this.date).format('MM/YYYY')}.xlsx`
      XLSX.writeFile(workBook, excelFileName)
    },
    getWeeksInMonth() {
      const startDate = moment(this.date).startOf('month')
      const endDate = moment(this.date).endOf('month')

      const weeks = []
      let currentDate = startDate.clone()
      while (currentDate.isBefore(endDate)) {
        // Ignore weekend
        if (parseInt(currentDate.format('d')) % 6 === 0) {
          currentDate.add(1, 'day')
          continue
        }
        const weekStart = currentDate.clone()
        let weekEnd = currentDate.clone().add(4, 'days')
        while (weekEnd.isAfter(endDate)) {
          weekEnd.subtract(1, 'day')
        }
        weeks.push({
          weekStart,
          weekEnd
        })
        currentDate.add(1, 'week')
      }
      return weeks
    }
  }
}
</script>
